module.exports = __webpack_public_path__ + "img/2_004.43bb69d9.webp";